import React from "react";
import { createPortal } from "react-dom";
import { X, Mail } from "lucide-react";

export const EmailPreviewModal = ({ preview, onClose }) => createPortal(
  <div className="fixed inset-0 z-[60] bg-black/80 backdrop-blur-sm flex items-start justify-center p-4 overflow-y-auto" onClick={onClose}>
    <div className="card max-w-3xl w-full my-8 relative overflow-hidden" onClick={(e) => e.stopPropagation()} data-testid="email-preview-modal">
      <div className="flex items-center justify-between gap-4 p-5 border-b border-white/10">
        <div className="min-w-0">
          <div className="chip chip-cyan mb-2"><Mail className="w-3 h-3" /> Pratinjau Email</div>
          <div className="text-xs font-mono text-slate-500 uppercase tracking-widest">Subjek</div>
          <div className="font-heading font-bold truncate" data-testid="email-preview-subject">{preview.subject}</div>
        </div>
        <button onClick={onClose} className="text-slate-500 hover:text-white shrink-0" data-testid="email-preview-close">
          <X className="w-5 h-5" />
        </button>
      </div>
      <iframe title="Pratinjau email" srcDoc={preview.html} sandbox="" className="w-full h-[70vh] bg-[#07070A]" data-testid="email-preview-frame" />
    </div>
  </div>,
  document.body
);
